export default __webpack_public_path__ + "static/media/audit-02.775a5340.jpg";